module.exports = __webpack_public_path__ + "img/500.b42557e3.webp";